import React from 'react';
import { connect } from 'react-redux';
import IconDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import IconButton from 'material-ui/IconButton';

const OrderRowMore = props => {
  const { order, toggleRowState, rowsState } = props;
  let reqKeys = Object.keys(order.items);
  const morePosContainerStyle = {
    display: 'flex',
    flex: '0 0 80px',
    alignItems: 'center',
    marginLeft: '16px',
  }
  const morePosStyle = {
    fontSize: '12px',
    color: '#666',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '-12px'
  }
  return (
    <div style={morePosContainerStyle}>
      {reqKeys.length > 1 &&
        <div style={{display: 'flex'}}>
          <div style={morePosStyle}>
            <div>
              {`еще ${reqKeys.length - 1}`}
            </div>
            <div>
              поз
            </div>
          </div>
          <IconButton
            onClick={
              () => {
                toggleRowState(order.id);
              }
            }
          >
            {rowsState[order.id] === true ? <IconUp /> : <IconDown /> }
          </IconButton>
        </div>
      }
    </div>
  );
}

export default connect()(OrderRowMore);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/more.js